import React, { useEffect, useState } from "react";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import { useToast } from "hooks/toast";

import {
  addUploadedFile,
  cleanUpload,
  setAttachmentList,
} from "store/modules/attachment/actions";
import { IUpload } from "store/modules/attachment/interface";
import { useAppDispatch, useAppSelector } from "store/rootReducer";

import { stylesGlobalDefault } from "global/globalStyle";

import { hearingFileServiceV2 } from "services/hearingFile";

import concluded from "assets/upload_completed.svg";

import {
  Container,
  ContainerProgressBar,
  FileTitle,
  ConcludedIcon,
} from "./styles";

interface IUploadFileItem {
  item: IUpload;
  isMain?: boolean;
}

const UploadFileItem: React.FC<IUploadFileItem> = ({ item, isMain }) => {
  const [percentage, setPercentage] = useState(0);
  const [uploadCompleted, setUploadCompleted] = useState(false);
  const dispatch = useAppDispatch();
  const { addToast } = useToast();
  const { accessToken } = useAppSelector((state) => state.auth);

  useEffect(() => {
    (async () => {
      try {
        const fileToUpload = item.file.get("content");
        if (!(fileToUpload instanceof File)) {
          throw new Error("Arquivo ausente no FormData.");
        }

        const { data: uploadResponse, status } =
          await hearingFileServiceV2.uploadLargeFileStream({
            file: fileToUpload,
            hearingId: Number(item.hearingId),
            mainVideo: isMain,
            parentId: item.parentId,
            onProgress: (progress) => setPercentage(Math.min(progress, 99)),
            accessToken: accessToken!,
          });

        if (status >= 200 && status < 300 && uploadResponse?.ok !== false) {
          setPercentage(100);
          setUploadCompleted(true);
          return;
        }

        throw new Error(
          uploadResponse?.message || "Erro desconhecido no upload.",
        );
      } catch (error: any) {
        addToast({
          type: "error",
          title: "Erro no upload",
          description:
            error.message ||
            "Algo deu errado durante o processo de upload. Tente novamente mais tarde.",
        });
        dispatch(cleanUpload());
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (uploadCompleted) {
        const { data, status } =
          await hearingFileServiceV2.getAllDownloadsByHearingId(
            parseInt(item.hearingId),
          );

        if (status === 200) {
          const list = data?.data?.filter(
            (element: any) => element.type !== 1 && element.type !== 6,
          );

          dispatch(setAttachmentList(list));
          dispatch(addUploadedFile(item));

          addToast({
            type: "success",
            title: "Aviso",
            description: "Seu arquivo foi enviado com sucesso.",
          });
        }
      }
    })();
  }, [uploadCompleted]);

  return (
    <Container>
      <FileTitle>{item.payload.title}</FileTitle>
      <ContainerProgressBar>
        {uploadCompleted ? (
          <ConcludedIcon src={concluded} alt="" />
        ) : (
          <CircularProgressbar
            value={percentage}
            strokeWidth={15}
            background
            backgroundPadding={10}
            styles={buildStyles({
              backgroundColor: stylesGlobalDefault.blue,
              textColor: stylesGlobalDefault.white,
              pathColor: stylesGlobalDefault.white,
              trailColor: "transparent",
              strokeLinecap: "butt",
            })}
          />
        )}
      </ContainerProgressBar>
    </Container>
  );
};

export default UploadFileItem;
